export default __webpack_public_path__ + "static/media/credit_card.45891d28.svg";